export const occupationType = {
  0: "弓兵",
  1: "剑盾",
  2: "格斗",
  3: "法师",
  4: "战锤",
  5: "剑士",
  6: "圣职",
  7: "枪兵"
};

export const sexType = {
  0: "man",
  1: "woman"
};

export type SexKeyType = keyof typeof sexType;

export const propertyName = {
  STR: "力量",
  VIT: "体质",
  DEX: "敏捷",
  HP: "最大生命值",
  RHP: "生命缓和",
  ATK: "攻击力",
  DEF: "防御力",
  AS: "攻速",
  CRR: "暴击率",
  CRD: "暴击伤害"
};
export const propertyAttr = {
  STR: "STR",
  VIT: "VIT",
  DEX: "DEX",
  HP: "HP",
  RHP: "RHP",
  ATK: "ATK",
  DEF: "DEF",
  AS: "AS",
  CRR: "CRR",
  CRD: "CRD"
};
